import type { QuantumEvent } from '../level/timeline.js';

/**
 * A fixed, Tron-styled DOM panel that fades in the year/title/detail of a
 * history board when the player is near it. Crisp text (no SDF), and
 * pointer-events:none so it never blocks the touch zones.
 */
export interface BoardPanel {
  show(ev: QuantumEvent): void;
  hide(): void;
  dispose(): void;
}

export function createBoardPanel(parent: HTMLElement): BoardPanel {
  const el = document.createElement('div');
  el.className = 'board-panel';
  el.innerHTML =
    '<span class="board-year"></span><span class="board-title"></span><span class="board-detail"></span>';
  parent.appendChild(el);
  const year = el.querySelector('.board-year') as HTMLElement;
  const title = el.querySelector('.board-title') as HTMLElement;
  const detail = el.querySelector('.board-detail') as HTMLElement;

  return {
    show(ev) {
      year.textContent = ev.year;
      title.textContent = ev.title;
      detail.textContent = ev.detail;
      el.classList.add('visible');
    },
    hide() {
      el.classList.remove('visible');
    },
    dispose() {
      el.remove();
    },
  };
}
